export const TOOL_FRIENDLY_LABELS: Record<string, string> = {
  search_leads: 'Searching your leads',
  get_lead_details: 'Looking up lead details',
  move_lead_stage: 'Moving lead to a new stage',
  create_lead: 'Creating a new lead',
  create_leads_from_research: 'Creating leads from research results',
  update_lead_fields: 'Updating lead details',
  assign_lead: 'Assigning lead to a team member',
  add_tags: 'Adding tags to a lead',
  add_note: 'Adding a note',
  invoke_prospect_search: 'Starting deep research',
  enrich_profile: 'Enriching lead profile',
  web_search: 'Searching the web',
  search_research_companies: 'Searching research companies',
  draft_whatsapp_message: 'Drafting a WhatsApp message',
  send_whatsapp_message: 'Sending a WhatsApp message',
  request_lead_consent: 'Requesting lead consent',
  record_lead_consent: 'Recording lead consent',
  echo: 'Echoing input',
};

export function humanizeToolName(toolName: string): string {
  return toolName
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function getToolLabel(toolName: string | null | undefined): string | null {
  if (!toolName) return null;
  return TOOL_FRIENDLY_LABELS[toolName] ?? humanizeToolName(toolName);
}
